<template>
  <div class="sunshine-port">
    <Crumbs :info='info' :title='navList[0]'/>
    <div class="port-container">
      <div class="port-nav">
        <menu-com :navList='navList'></menu-com>
      </div>
      <div class="port-content">
        <h2>定制方案</h2>
        <p>确定合作并签署合作平台入驻合同后，平台专属服务人员在了解电商企业售货平台、境外收款方式、物流运输方式及公司经营需求后，为客户定制合规化解决方案，含报关、财税、收结汇和融资等。</p>
        <img src="../../../assets/images/other/ohter.jpg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import menuCom from "./common/menuCom.vue"
import Crumbs from "./common/Crumbs.vue"
import {navList} from "../../../model/enter"

export default {
  components:{
    menuCom,Crumbs
  },
  data () {
    return {
      info:{},
      navList,
    }
  },
  created(){
    const path=this.$route.fullPath;
    const index=navList.findIndex(item=>item.path===path);
    if(index!==-1){
      this.info=navList[index];
    }
  }
};
</script>

<style scoped>
.port-container {
  width: 1200px;
  height: 920px;
  margin: 0 auto;
  display: flex;
  padding: 34px 30px;
  border: 1px solid #d3d3d3;
  margin-top: 30px;
  margin-bottom: 186px;
}
.port-content {
  flex:1;
}
.port-content h2 {
  height: 38px;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #34373b;
  line-height: 38px;
  display: block;
  margin-bottom: 34px;
}
.port-content p {
  text-indent: 2em;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 34px;
  margin-bottom: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/Enter/Consult.vue